import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Button, CircularProgress } from "@mui/material";

import useStyles from "./styles";

const CustomButton = (props) => {
  const classes = useStyles();

  const {
    color,
    variant,
    className,
    pendingClassname,
    pending,
    children,
    onClick,
    ...restProps
  } = props;

  return (
    <Button
      color={color}
      variant={variant}
      className={classNames(className, {
        [classes.primaryButton]: color === "primary" && variant === "contained",
      })}
      onClick={(event) => (pending ? {} : onClick?.(event))}
      {...restProps}
    >
      {pending ? (
        <CircularProgress className={pendingClassname} size={20} />
      ) : (
        children
      )}
    </Button>
  );
};

CustomButton.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  pendingClassname: PropTypes.string,
  pending: PropTypes.bool,
  children: PropTypes.any,
  onClick: PropTypes.func,
};

export default CustomButton;
